/*
 * Custom JavaScript
 * ===========================================================================
 * Variantes de couleur mises en avant selon la collection.
 */

(function () {
  const COLLECTION_VARIANTS = {
    'sac-a-main-noir': [
      'Noir',
      'Noir et rose',
      'Réglisse',
      'Perle obsidienne',
      'Libellule noir',
      'Noir floral',
      'Noir contrasté',
      'Noir Absolu'
    ],
    'sac-a-main-marron': [
      'Marron',
      'Marron fumé',
      'Chocolat',
      'Acajou Profond'
    ],
    'sac-a-main-blanc': [
      'Blanc',
      'Ivoire',
      'Ombre florale',
      'Blanc cassé'
    ],
    'sac-a-main-bordeaux': [
      'Bordeaux',
      'Bourgogne Profond',
      'Châtaigne Profonde'
    ],
    'sac-a-main-beige': [
      'Beige',
      'Beige clair',
      'Beige foncé'
    ],
    'sac-a-main-rose': [
      'Rose',
      'Fraise rose'
    ],
    'sac-a-main-rouge': [
      'Rouge',
      'Rouge et bleu'
    ]
  };

  const cache = new Map();
  const processed = new WeakSet();

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  function currentCollectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  const collectionHandle = currentCollectionHandle();
  const targetNames = COLLECTION_VARIANTS[collectionHandle];

  if (!targetNames) return;

  const normalizedTargetNames = targetNames.map(normalize);

  function productEndpoint(href) {
    const url = new URL(href, window.location.origin);
    url.search = '';
    url.hash = '';
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    return url.toString();
  }

  function productUrlWithVariant(href, variantId) {
    const url = new URL(href, window.location.origin);
    url.searchParams.set('variant', variantId);
    return url.pathname + url.search;
  }

  function imageUrl(source, width) {
    const url = new URL(source, window.location.origin);
    url.searchParams.set('width', width);
    return url.toString();
  }

  async function getProduct(href) {
    const endpoint = productEndpoint(href);

    if (!cache.has(endpoint)) {
      cache.set(
        endpoint,
        fetch(endpoint, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('Produit introuvable');
            return response.json();
          })
          .catch(() => null)
      );
    }

    return cache.get(endpoint);
  }

  function findMatchingVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;

    return product.variants.find((variant) => {
      const values = [
        variant.title,
        variant.option1,
        variant.option2,
        variant.option3
      ]
        .map(normalize)
        .filter(Boolean);

      return values.some((value) => normalizedTargetNames.includes(value));
    }) || null;
  }

  function variantImage(variant) {
    if (!variant || !variant.featured_image) return '';
    return variant.featured_image.src || variant.featured_image.url || '';
  }

  function updateImageElement(img, source) {
    if (!img || !source) return;

    img.src = imageUrl(source, 533);
    img.srcset = [165, 360, 533, 720, 940, 1066]
      .map((width) => imageUrl(source, width) + ' ' + width + 'w')
      .join(', ');
  }

  async function enhanceCard(card) {
    if (processed.has(card)) return;
    processed.add(card);

    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    const product = await getProduct(link.href);
    if (!product || !card.isConnected) return;

    const variant = findMatchingVariant(product);
    if (!variant) return;

    const variantUrl = productUrlWithVariant(link.href, variant.id);
    const source = variantImage(variant);

    card.querySelectorAll('a[href*="/products/"]').forEach((productLink) => {
      productLink.href = variantUrl;
    });

    card.querySelectorAll('[data-product-url]').forEach((element) => {
      element.dataset.productUrl = variantUrl;
    });

    updateImageElement(card.querySelector('.card__media > .media img'), source);
    updateImageElement(card.querySelector('.card__inner .media img'), source);

    card.dataset.zaneziaVariant = String(variant.id);
  }

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('.product-card-wrapper')) {
      enhanceCard(scope);
    }

    scope.querySelectorAll('.product-card-wrapper').forEach(enhanceCard);
  }

  scan(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });
})();
